import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { addShape } from '../helpers/handleShapes'
import { useTranslation } from "react-i18next";
import ShapesModal from "./shapes/ShapesModal";

function ShapeSelection(props) {
  const { t } = useTranslation();
  const [showShapesModal, setShowShapesModal] = useState(false);

  const handleShapeSelect = (shapeType) => {
    addShape(shapeType, props);
  };

  return (
    <div className="d-inline dropup">
      {/* Shapes Button - Opens Shapes Modal Directly */}
      <button
        className="btn mt-1 btn-block pb-0 m-0 btn-primary btn-sm"
        onClick={() => setShowShapesModal(true)}
      >
        <img
          className="shapesButton"
          src="/icons/shapesButton.png"
          height="40px"
          alt="Shapes"
          title={t("shapeSelection-shapes")}
        />
      </button>

      {/* Shapes Modal */}
      <ShapesModal
        show={showShapesModal}
        onHide={() => setShowShapesModal(false)}
        onShapeSelect={handleShapeSelect}
        title={t("shapeSelection-shapes", "Shapes")}
      />
    </div>
  );
}

export default ShapeSelection;
